module.exports = __webpack_public_path__ + "media/assets/images/email_icon-160a6010e180da253390047449f9ed55.png";